// B-151 — a document's photo (an arqueo, a GLORY screen) in the closing detail's viewer: whole in the
// panel when it opens, then larger or smaller with the buttons, or with a double click between the
// whole picture and twice its size. Until B-151 it was drawn at its own size, so a phone photo
// showed one corner of the form and there was no way to see it all.
import { useEffect, useState } from "react";
import { Maximize2, ZoomIn, ZoomOut } from "lucide-react";
import { cn } from "@mantis-sas/ui";

export const ZOOM_MIN = 1;
export const ZOOM_MAX = 4;
const PASO = 0.5;

const BOTON =
  "grid h-7 w-7 place-items-center rounded-[6px] text-brinks-foreground hover:bg-brinks-surface disabled:cursor-not-allowed disabled:opacity-40";

export function VisorImagen({ url, nombre }) {
  // 1 is the whole picture in the panel; above it, that many times the panel's width.
  const [zoom, setZoom] = useState(ZOOM_MIN);
  useEffect(() => setZoom(ZOOM_MIN), [url]);

  const acercar = () => setZoom((actual) => Math.min(ZOOM_MAX, actual + PASO));
  const alejar = () => setZoom((actual) => Math.max(ZOOM_MIN, actual - PASO));
  const ajustada = zoom === ZOOM_MIN;

  return (
    <div className="relative h-[54vh] w-full">
      <div className="absolute right-2 top-2 z-10 flex items-center gap-0.5 rounded-[8px] border bg-card p-0.5 shadow-brinks-card">
        <button type="button" onClick={alejar} disabled={ajustada} className={BOTON} aria-label="Alejar">
          <ZoomOut className="h-4 w-4" />
        </button>
        <span className="min-w-[42px] text-center text-[11px] tabular-nums text-brinks-muted-foreground">
          {Math.round(zoom * 100)}%
        </span>
        <button type="button" onClick={acercar} disabled={zoom >= ZOOM_MAX} className={BOTON} aria-label="Acercar">
          <ZoomIn className="h-4 w-4" />
        </button>
        <button type="button" onClick={() => setZoom(ZOOM_MIN)} disabled={ajustada} className={BOTON} aria-label="Ajustar a la pantalla">
          <Maximize2 className="h-4 w-4" />
        </button>
      </div>
      <div className={cn("h-full w-full overflow-auto rounded-[6px] border bg-card", ajustada && "grid place-items-center")}>
        <img
          src={url}
          alt={nombre}
          onDoubleClick={() => setZoom(ajustada ? 2 : ZOOM_MIN)}
          className={cn("select-none", ajustada ? "max-h-full max-w-full cursor-zoom-in object-contain" : "max-w-none cursor-zoom-out")}
          style={ajustada ? undefined : { width: `${zoom * 100}%` }}
        />
      </div>
    </div>
  );
}
